export {
  SegmentedControl,
  SegmentedControlItem,
  type SegmentedControlProps,
  type SegmentedControlItemProps,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/SegmentedControl';
